(ns frontend.react.virtualized.scrollable-grid.events
  (:require
   [frontend.actions.entity :as entity-actions]
   [common.util :as cu]
   [clojure.string :as string]
   [common.entity :as entity]))

(defn calculate-current-column-width
  [columns index avail-width]
  (let [column (get columns index)
        all-cols-width (apply + (map :width columns))
        unused-width (- avail-width all-cols-width)
        ;min-active-prio (apply min (map :grow-priority columns)) ;; not excluding user set widths
        #_min-active-unset-prio
        #_(->> columns
               (filter (fn [c]
                         (nil? (:set-width c))))
               (map :grow-priority)
               (apply min))
        has-unset-widths? (some nil? (map :set-width columns))
        resolved-width (if (or true                         ;;note: quick and dirty - keep unused width as unused
                               (<= unused-width 0)
                               ;(and min-active-unset-prio (not= min-active-unset-prio (:grow-priority column))) ;; this col not priority
                               ;(and (not min-active-unset-prio) (not= min-active-prio (:grow-priority column)))) ;; no unset cols and this is not priority
                           )
                         (:width column)
                         (+ (:width column) unused-width))]
    resolved-width))

(defn filter-pipelines-by-search
  [search-value pipelines]
  (let [search-str-lc (cu/str-trim-lcase search-value)]
    (if (empty? search-str-lc)
      pipelines
      (->> pipelines
           (filter (fn [pipeline]
                     (string/includes? (string/lower-case (entity/display-string pipeline))
                                       search-str-lc)))))))

(defn sort-named-views
  [named-views]
  (->> named-views
       (sort (fn [a b]
               (let [aid (int? (:db/id a))                  ;; system-views do not have numeric id
                     bid (int? (:db/id b))]
                 (cond
                   (and (not aid)
                        (not bid))
                   (compare (:common/created-on a)
                            (:common/created-on b))

                   (and aid (not bid))
                   1                                    ;; system views first

                   (and bid (not aid))
                   -1
                   :else
                   (compare (cu/str-trim-lcase (:named-view/name a)) ;; then sort by name
                            (cu/str-trim-lcase (:named-view/name b)))))))))

;;tooltip with overlay-if screws up the popover positioning - needs
;; delay for the possible target element change to take place
(defn show-popover!
  [local-state]
  (swap! local-state dissoc :show-tooltip?)
  (js/setTimeout
   (fn []
     (swap! local-state assoc :show? true))
   100))

(defn hide-popover!
  [local-state]
  (swap! local-state dissoc
    :show?
    :share-with
    :search
    :share-view-id
    :processing?
    :error-while-sharing?)
  (js/setTimeout
   (fn []
     (swap! local-state assoc :show-tooltip? true))
   100))

(defn update-with-new-entity!
  [{:keys [enriched-entity attribute value create-value
           on-success! on-error!]}]
  (entity-actions/*->field-update-with-new-entity!
   (:db/id enriched-entity)
   attribute
   value
   create-value
   on-success!
   on-error!))

(defn update-entity!
  [{:keys [enriched-entity attribute new-value on-success! on-error!]}]
  (entity-actions/*->field-update!
   (:db/id enriched-entity)
   attribute
   new-value
   on-success!
   on-error!))
